import { z } from "zod"
import { joinAddress } from "../blockchain/address"
import type { NftId } from "../nft/types"
import type { CollectionId } from "./types"

export function toCollectionId(address: string) {
  return address as CollectionId
}

export function getCollectionIdFromNftId(nftId: NftId) {
  const [blockchain, collectionAddress] = nftId.split(":")

  return toCollectionId(joinAddress(blockchain, collectionAddress))
}

export const COLLECTION_ID_VALIDATION = z
  .string()
  .refine((value) => {
    try {
      toCollectionId(value)

      return true
    } catch (e) {
      return false
    }
  })
  .transform((value) => toCollectionId(value))
